import React, { useState, useEffect } from "react";
import "../../styles/generals/homepage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Slider1 from '../../images/slider1.jpg';
import Slider2 from '../../images/slider2.jpg';
import Slider3 from '../../images/slider3.jpg';
import Slider4 from '../../images/slider4.jpg';
import 'animate.css'

function AdminsLogin(props) {
  const navigate = useNavigate();
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({ ...prev, [name]: value }));
  };

  // Submit form data
  const handleSubmit = async (e) => {
    e.preventDefault();
    props.handleLoading();
    try {
      const response = await axios.post(
        "https://api.dectwinservices.com/api/admin-login",
        loginData
      );

      props.handleToast({
        toastMsg: "Login Successfully!!!",
        toastColor: "#4CAF50",
      });
      localStorage.setItem("exclserv_user", JSON.stringify(response.data));
      navigate("/admin/dashboard");
    } catch (error) {
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
    props.closeLoading();
  };

    const images = [
    Slider1,
    Slider2,
    Slider3,
    Slider4
];
const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2000);
    return () => clearInterval(interval);
  }, []);


  return (
            <section>
      <div className="slide-outer">

    <div className="slideshow-container">
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="slideshow-image"
      />
    </div>


{/* <div className="col"> */}
  <div className="col-right">
                    <div className="form-wrapper animate__animated animate__zoomIn">
<div className="form sign-in">
  <br />
            <span className="welcome-text">Welcome Admin</span>
<br />
<br />
           <div className="input-group">
             <i className="bx bxs-user"></i>
             <input
              type="text"
              name="username"
               style={{backgroundColor: 'white'}}
              placeholder="Company Username"
              value={loginData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <i className="bx bxs-lock-alt"></i>
            <input
              type="password"
              name="password"
               style={{backgroundColor: 'white'}}
              placeholder="Your Password"
              value={loginData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button onClick={handleSubmit}>Sign in</button>
          <br />
          <br />
          {/* <p>
            <b>Forgot password?</b>
          </p> */}
</div>
</div>
  </div>
{/* </div> */}

</div>

      <div className="social-media-area">
        <p className="social-icon"><a style={{color: 'blue'}} href='https://www.facebook.com/share/g/14EkfQo5u1f/' target="_blank"><i className="fa-brands fa-facebook"></i></a></p>
         <p className="social-icon"><a style={{color: 'red'}} href='https://www.instagram.com/exclservsolutionsllp?igsh=ejBhYjZ4bG5ncW43' target="_blank"><i className="fa-brands fa-instagram"></i></a></p>
         <p className="social-icon"><a style={{color: 'blue'}} href='https://linkedin.com/company/exclserv-solutions-llp' target="_blank"><i className="fa-brands fa-linkedin"></i></a></p>
         <p className="social-icon"><a style={{color: 'green'}} href='https://wa.me/9599039841' target="_blank"><i className="fa-brands fa-whatsapp"></i></a></p>
         <p className="social-icon"><a style={{color: 'blue'}} href='https://exclserv.in/' target="_blank"><i className="fa-solid fa-globe"></i></a></p>
      </div>

</section>

  );
}

export default AdminsLogin;
